import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "@/components/ui/card";
import { DataTable } from "@/components/data-table";
import SuccessRatePerTopicChart from "./success-rate-per-topic-chart";
import { successRatePerTopicColumns } from "./success-rate-per-topic-columns";
import type { ApiSuccessRatePerTopicStat } from "../types";

interface SuccessRatePerTopicProps {
  data: ApiSuccessRatePerTopicStat[];
  isLoading: boolean;
}

const SuccessRatePerTopic = ({ data, isLoading }: SuccessRatePerTopicProps) => {
  const { t } = useTranslation();
  const columns = useMemo(() => successRatePerTopicColumns(t), [t]);

  return (
    <Card className="p-4 flex flex-col gap-4">
      <p className="font-semibold">
        {t("modules.stats.part2.success_rate_per_topic.title")}
      </p>
      <SuccessRatePerTopicChart data={data} isLoading={isLoading} />
      <div className="overflow-x-auto">
        <DataTable columns={columns} data={data} isLoading={isLoading} />
      </div>
    </Card>
  );
};

export default SuccessRatePerTopic;
